import React, { PureComponent } from 'react';
import { Row, Col, Button, ButtonToolbar } from 'reactstrap';
import PlusThickIcon from 'mdi-react/PlusThickIcon';
import { withTranslation } from 'react-i18next';
import { check, findAllMeioAmbienteTipologia } from "../../Services/MeioAmbienteTipologiaService";
import { findAllMeioAmbienteAreasByEnabled } from "../../Services/MeioAmbienteAreasService";
import { findAllMeioAmbienteGrupoByEnabled } from "../../Services/MeioAmbienteGrupoService";
import { checkKey, hasAccess } from "../../Services/SecurityService";
import PropTypes from 'prop-types';
import MatTable from './MaterialTable/MatTable';
import CrudEdit from './edit';
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

class CrudList extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.setSelected = this.setSelected.bind(this)

    this.state = {
      selected: {},
      grupos: [],
      data: []
    };
    check();
  }

  loadMeioAmbienteTipologia(selected){
    findAllMeioAmbienteTipologia()
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        this.setState({ data: data, selected });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadMeioAmbienteGrupo(){
    findAllMeioAmbienteGrupoByEnabled(0)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        this.loadMeioAmbienteAreas(data);
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  loadMeioAmbienteAreas(grupos){
    findAllMeioAmbienteAreasByEnabled(0)
    .then(data => {
      if(data === undefined){
        data = [];
      }
      if(data !== undefined && data.error === undefined){
        let areas = [];
        for(let i = 0; i < grupos.length; i++){
          areas = [];
          for(let j = 0; j < data.length; j++){
            if(data[j].meioAmbienteGrupo !== null && data[j].meioAmbienteGrupo.id === grupos[i].id){
              areas.push(data[j]);
            }
          }
          grupos[i].areas = areas;
        }
        this.setState({ grupos });
      } else {
        if(data.errors === undefined){
          data = [];
          this.show('danger', this.props.t('forms.errorListData'));
        } else {
          data = [];
          this.show('danger', data.errors[0].defaultMessage);
        }
      }
    });
  }

  componentDidMount() {
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
    if(checkKey("MENU_MEIO_AMBIENTE_TIPOLOGIA_VIEW")){
      this.loadMeioAmbienteTipologia({});
      this.loadMeioAmbienteGrupo();
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  setSelected = (selected) => {
    this.loadMeioAmbienteTipologia(selected);
  }

  setSelectedNew = () => {
    this.setState({ selected: {id: 0} });
  }

  updateTable = (selected, msg = null, success = true) => {
    this.loadMeioAmbienteTipologia(selected);
    if(msg != null){
      if(success){
        this.show('success', msg);
      }else{
        this.show('danger', msg);
      }
    }
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  render() {
    const { t } = this.props;
    
    let notOK = !hasAccess("MENU_MEIO_AMBIENTE_TIPOLOGIA_NEW");

    let view = '';
    let disabled = false;
    if(this.state.selected.id !== null && this.state.selected.id !== undefined){
      disabled = (this.state.selected.id === 0);
      view =  <CrudEdit 
                selected = {this.state.selected}
                grupos = {this.state.grupos}
                updateTable = {this.updateTable} />
    }else{
      view =  <MatTable 
                title={t('forms.list')}
                list={this.state.data}
                setSelected = {this.setSelected}
                updateTable = {this.updateTable} />
    }

    return (
      <>
        <Row>
          <Col md={10}>
            <h3 className="page-title">{t('forms.meioAmbienteTipologia_form.title')}</h3>
            <h3 className="page-subhead subhead">{t('forms.meioAmbienteTipologia_form.description')}</h3>
          </Col>
          <Col md={2}>
            <ButtonToolbar className="form__button-toolbar" style={{float: 'right'}}>
              <Button className="icon" color="primary" type="submit" disabled={disabled || notOK}
                onClick={e => this.setSelectedNew()}>
                <PlusThickIcon /> {t('forms.new')}
              </Button>
            </ButtonToolbar>
          </Col>
        </Row>

        <Row>
          {view}
        </Row>
      </>
    );
  }
}

export default withTranslation('common')(CrudList);